import styled from 'styled-components';
import { ThemeColours } from '../../../../../../styles/ThemeColours';
import { FONT_STACK } from '../../../../../../styles/constants';

export const Container = styled.div`
  ${FONT_STACK};
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  min-height: 52px;
  padding: 10px 4px;
`;

export const Visual = styled.div`
  align-items: flex-start;
  align-self: flex-start;
  background-color: ${ThemeColours.mono200};
  border-radius: 100px;
  display: flex;
  height: 40px;
  justify-content: left;
  width: 40px;
`;

export const SpecialtyVisual = styled.div`
  align-items: flex-start;
  align-self: flex-start;
  background-color: ${ThemeColours.primary300};
  border-radius: 100px;
  display: flex;
  height: 40px;
  justify-content: left;
  width: 40px;
`;

export const PracticeVisual = styled.div`
  align-items: flex-start;
  align-self: flex-start;
  background-color: ${ThemeColours.mono200};
  border-radius: 4px;
  display: flex;
  height: 40px;
  justify-content: left;
  width: 40px;
`;

export const Descriptor = styled.div`
  display: flex;
  flex-direction: column;
  margin-inline-start: 16px;
`;
